// extracted by mini-css-extract-plugin
module.exports = {"shadow":"ImpactAnalysis_shadow__1SOcf","summary":"ImpactAnalysis_summary__35PwB","header":"ImpactAnalysis_header__3Nfvw"};